import { FetchResult, gql } from 'apollo-boost';
import { IIpHolder } from '../../../models/ip-holder';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation IpHolderSave($ipHolder: IPHolderInput!){
        ip_holder_save (ip_holder_data: $ipHolder) {
            uid
        }
    }
`;

export async function ipHolderSave(ipHolder: Partial<IIpHolder>): Promise<string> {
    const result: FetchResult<{ ip_holder_save: { uid: string }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { ipHolder: {
            uid: ipHolder.uid,
            identifier: ipHolder.identifier,
            name: ipHolder.name,
            url: ipHolder.url,
            details: ipHolder.details,
            block_photo_activity: ipHolder.blockPhotoActivity,
        } },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.ip_holder_save?.uid;
}

